import axios from "axios";
import Cookies from 'js-cookie';
import { getLanguageCode,addGeoParam } from "../../utils/getURLParams";
import { markOrderPaymentStatusFailed } from "../../utils/markPaymentAsFailed";
import { getDomainConfig } from "../../config/config";
import API from "../../api/phx";
import ExitPopUp from '../../utils/exitPopUp';

export function applePay(
  orderContext,
  orderId,
  amountToPay,
  currency,
  countryCode,
  appleSession,
  showFormFunc,
  applePayFailed,
  showPayWithExternalPaymentMethodFunc,
  setOrder,
  setOrderCreationStatus,
  setOpenModal) {

  const domainConfig = getDomainConfig();

  const BACKEND_URL_VALIDATE_SESSION = `https://${window.location.hostname}/api/payments/apple-pay-validate-session?cached=0&geo=${addGeoParam()}`
  const BACKEND_URL_PAY = `https://${window.location.hostname}/api/payments/checkoutdotcom/apple-pay?cached=0&geo=${addGeoParam()}`

  const validateApplePaySession = (appleUrl, callback) => {
    axios
      .post(
        BACKEND_URL_VALIDATE_SESSION,
        {
          appleUrl
        },
        {
          headers: { 'Access-Control-Allow-Origin': '*' }
        }
      )
      .then(function (response) {
        callback(response.data)
      })
  }

  const performTransaction = (details, callback) => {

    orderContext.amountToPay = (amountToPay * 100).toFixed();
    orderContext.currency = currency;
    orderContext.countryCode = countryCode;
    orderContext.order_id = orderId;
    details.orderData = orderContext;

    axios
      .post(
        BACKEND_URL_PAY,
        {
          details
        },
        {
          headers: { 'Access-Control-Allow-Origin': '*' }
        }
      )
      .then(function (response) {
        callback(response.data)
      })
  }


  const handleApplePayEvents = () => {

    // This is the first event that Apple triggers. Here you need to validate the
    // Apple Pay Session from your Back-End
    appleSession.onvalidatemerchant = function (event) {
      validateApplePaySession(event.validationURL, function (merchantSession) {
        appleSession.completeMerchantValidation(merchantSession)
      })
    }

    // This method is the most important method. It gets triggered after teh user has
    // confirmed the transaction with the Touch ID or Face ID. Besides getting all the
    // details about the customer you also get the Apple Pay payload needed to perform
    // a payment.
    appleSession.onpaymentauthorized = function (event) {
      performTransaction(event.payment, function (outcome) {
        if (outcome.approved && !outcome.risk.flagged) {
          try {
            // eslint-disable-next-line no-undef
            appleSession.completePayment(ApplePaySession.STATUS_SUCCESS);
          } catch(err){
            console.error(JSON.stringify(err))
          }
            setOrderCreationStatus("finalizing");
            API.delete("/cart").then(() => {
              Cookies.set("orderDoComplete",true);
              Cookies.set("risk",false);
              Cookies.set("flagged",false);
              Cookies.set("display",true);
              ExitPopUp.Disable();
              window.location.href = `${getLanguageCode(
                domainConfig.brand,
                true
              )}/cart/checkout/complete/${orderId}`;
          });

        } else if (outcome.approved && outcome.risk && outcome.risk.flagged) {
            let complete = 'complete';
            setOrderCreationStatus("finalizing");
            try {
              // eslint-disable-next-line no-undef
              appleSession.completePayment(ApplePaySession.STATUS_SUCCESS);
            } catch(err){
              console.error(JSON.stringify(err))
            }

            if(domainConfig.brand === "Atd"){
              // Changing "complete" to "incomplete" for WL projects as UWL,SW where redirects happening just to /cart/checkout/complete/{order_id} page
              complete = 'incomplete';
            }
            API.delete("/cart").then(() => {
                Cookies.set('orderDoComplete',false);
                Cookies.set('flagged',true);
                Cookies.set('display',false);

                ExitPopUp.Disable();
                window.location.href = `${getLanguageCode(
                  domainConfig.brand,
                  true
                )}/cart/checkout/${complete}/${orderId}`;
            });

        } else {
            try {
              // eslint-disable-next-line no-undef
              appleSession.completePayment(ApplePaySession.STATUS_FAILURE);
            } catch(err){
              console.error(JSON.stringify(err));
            }
            setOpenModal(false);
            setOrder({});
            markOrderPaymentStatusFailed(orderId,false,'Apple Pay');
            applePayFailed();
            showFormFunc();
            showPayWithExternalPaymentMethodFunc(false);
        }
      })
    }
    appleSession.oncancel = function (event) {
      setOpenModal(false);
      setOrder({});
      applePayFailed()
      showPayWithExternalPaymentMethodFunc(false);
      markOrderPaymentStatusFailed(orderId, true, 'Apple Pay').then(() => {
        showFormFunc();
      });
    }
  }

  handleApplePayEvents();
}


